<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ title }}</h3>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.id') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="user.username" :rules="[rules.required]" class="w-auto" outlined dense :disabled="isAddUser"></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.name') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="user.name" :rules="[rules.required]" class="w-auto" data-v-min="5" ref="name" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.password') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="user.password" type="password" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.confirmPassword') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="confirmationPassword" ref="confirmationPassword" type="password" :rules="[rules.required, rules.passwordMatch]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.email') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="user.email" :rules="[rules.required, rules.email]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.phoneNumber') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="user.cellPhoneNumber" type="number" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.push.id') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="user.pushId" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('common.theme') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="user.theme" :items="themes" item-text="text" item-value="value" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('common.language') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="user.language" :items="languages" item-text="text" item-value="value" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.timeZone') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-autocomplete v-model="user.timeZoneId" :items="timeZones" item-text="name" item-value="id" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" dense outlined
                ></v-autocomplete>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('user.role') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="user.role" :items="roles" item-text="text" item-value="value" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col v-if="user.username == 'admin' && username == 'admin'" cols="6" />
          <!-- 현재 편집 중인 사용자가 'admin'이 아니고 로그인 사용자가 'admin'이면 메뉴접근권한 설정 버튼을 보여준다.2026.07.15.KWShin. -->
          <v-col v-if="user.username != 'admin' && username == 'admin'" cols="6" class="pr-5">
            <div class="my-1">
              <v-btn @click="openUserMenuControl()" small color="primary">{{ this.$t('user.menu.settings') }}</v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="12">
            <v-card flat class="dialog-form" :class="classContents">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('user.defaultSystem') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <v-select v-model="user.defaultTargetMonitoringSystemId" :items="systems" item-text="id" item-value="id" class="w-auto"
                      :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                    ></v-select>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('user.montoringSystem') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <v-select
                      v-model="user.targetMonitoringSystemIds" :items="systems" item-text="id" item-value="id"
                      class="w-auto" :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }"
                      multiple outlined dense
                    />
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <!-- <v-btn @click="save" :disabled="!valid" :loading="loading" small>{{ this.$t('common.save') }}</v-btn> -->
        <v-btn :loading="loading" small color="primary" @click="save">{{ this.$t('common.save') }}</v-btn>
        <v-btn small color="primary" @click="close">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
    <user-menu-control v-model="showControl" :userId="userId" :userRole="user.role" @close="showControl = false" />
  </v-dialog>
</template>

<script>
// https://stackoverflow.com/questions/48035310/open-a-vuetify-dialog-from-a-component-template-in-vuejs
// https://codeburst.io/es6-destructuring-the-complete-guide-7f842d08b98f
import { mapState } from 'vuex';
import { api } from '@/api/common/instances';
import validation from '@/utils/validation';
import UserMenuControl from './UserMenuControl.vue';

const DEFAULT_USER = Object.freeze({
  username: '',
  password: '',
  name: '',
  email: '',
  cellPhoneNumber: '',
  pushId: '',
  language: 'ko',
  timeZoneId: 'Asia/Seoul',
  role: '',
  theme: 'dark',
  defaultTargetMonitoringSystemId: '',
  targetMonitoringSystemIds: [],
});

export default {
  components: {
    UserMenuControl,
  },
  props: {
    userId: String,
    value: Boolean,
  },
  data() {
    return {
      valid: true,
      loading: false,
      user: Object.assign({}, DEFAULT_USER),
      confirmationPassword: '',
      title: '',
      systems: [],
      timeZones: [],
      themes: [
        { value: 'dark', text: this.$t('common.themes.dark') },
        { value: 'light', text: this.$t('common.themes.light') },
      ],
      roles: [
        { value: 'ROLE_ADMIN', text: this.$t('user.role.admin') },
        { value: 'ROLE_USER', text: this.$t('user.role.user') },
      ],
      languages: Object.keys(this.$i18n.messages).map(lang => ({
        value: lang,
        text: this.$i18n.messages[lang]['common.localLanguageName'],
      })),
      rules: {
        ...validation,
        passwordMatch: () => {
          return this.user.password === this.confirmationPassword || this.$t('validation.password.notMatch');
        },
      },
      showControl: false,
    };
  },
  computed: {
    ...mapState('common/user', ['username']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isAddUser() {
      return !!this.userId;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    async show(value) {
      if (value && this.userId) {
        ({ data: this.user } = await api.get(`/preference/users/${this.userId}`));
        this.confirmationPassword = this.user.password;
      }
      this.title = this.userId ? this.$t('user.title.edit') : this.$t('user.title.add');
    },
    user: {
      deep: true,
      handler() {
        // console.log('changed');
      },
    },
    'user.password': {
      immediate: true,
      handler() {
        const elem = this.$refs['confirmationPassword'];
        if (elem) {
          elem.validate();
        }
      },
    },
  },
  async created() {
    ({ data: this.systems } = await api.get('/preference/systems'));
    ({ data: this.timeZones } = await api.get('/timezones'));
  },
  methods: {
    async save() {
      this.startLoading();
      let response;
      const user = Object.assign({}, this.user);
      if (this.userId) {
        response = await this.update(user);
      } else {
        response = await this.add(user);
      }

      const { status } = response;
      if (status === 200) {
        this.$emit('change', user);
        this.close();
      }
      this.finishLoading();
    },
    add(user) {
      return api.post('/preference/users', user);
    },
    update(user) {
      return api.put(`/preference/users/${user.username}`, user);
    },
    close() {
      this.user = Object.assign({}, DEFAULT_USER);
      this.confirmationPassword = '';
      this.show = false;
      // this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    startLoading() {
      this.loading = true;
    },
    finishLoading() {
      this.loading = false;
    },
    // BEGIN::Added.by.KWShin.2026.07.15.
    openUserMenuControl() {
      this.showControl = true;
    },
    // FINISH::Added.by.KWShin.2026.07.15.
  },
};
</script>
